export default [
  { value: 'HT', label: 'Hunt Test' },
  { value: 'FT', label: 'Field Trial' }
]
